// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import {
  BookHourlyCoachingModalCoachingFocusFragmentDoc,
  BookHourlyCoachingModalCoachFragmentDoc,
} from '../../__generated-gql-types__/BookHourlyCoachingModal.generated';
import { BaseScheduleSubmissionModalLayoutCoachFragmentDoc } from './BaseScheduleSubmissionModalLayout.generated';
import {
  BookCoachingTimeFormCoachFragmentDoc,
  BookCoachingTimeFormCoachingFocusFragmentDoc,
} from '../../BookHourlyCoachingModal/__generated-gql-types__/BookCoachingTimeForm.generated';
import {
  BaseScheduleModalLayoutCoachingSessionFragmentDoc,
  BaseScheduleModalLayoutOrderFragmentDoc,
  BaseScheduleModalLayoutRecurringCadenceFragmentDoc,
} from './BaseScheduleModalLayout.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddAdditionalTimeCoachFragment = {
  __typename?: 'Coach';
  id: string;
  hourlyRate?: number | null;
  tier: Types.SkuTier;
  slug: string;
  averageReviewRate: number;
  reviewTotal: number;
  couldScheduleIntro?: boolean | null;
  everHadCoachingSessionWithCoach?: boolean | null;
  coachingTimeSummary?: {
    __typename?: 'CoachingTimeSummary';
    availableTime: number;
    hasUnlimitedPackage: boolean;
  } | null;
  categoryInformationList?: Array<{
    __typename?: 'CategoryInformation';
    id: string;
    category: { __typename?: 'Category'; id: string };
    coachingFocusList?: Array<{
      __typename?: 'CoachingFocus';
      id: string;
      name: string;
    }> | null;
  }> | null;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
  };
  mostRecentOrder?: {
    __typename?: 'Order';
    hourlyOrder?: { __typename?: 'HourlyOrder'; timeInMinute: number } | null;
  } | null;
  coachingRelationship?: {
    __typename?: 'CoachingRelationship';
    id: string;
    customerSubscription?: {
      __typename?: 'CustomerSubscription';
      id: string;
      sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
    } | null;
  } | null;
};

export type AddAdditionalTimeCoachingSessionFragment = {
  __typename?: 'CoachingSession';
  id: string;
  startAt: number;
  endAt: number;
  durationInMinute: number;
  content:
    | {
        __typename: 'BootcampSession';
        bootcamp: { __typename?: 'Bootcamp'; id: string; title: string };
      }
    | { __typename: 'Class'; id: string; name?: string | null }
    | {
        __typename: 'OneOnOneSession';
        title: string;
        introOrder?: {
          __typename?: 'Order';
          introCall?: {
            __typename?: 'IntroCall';
            packages?: Array<{
              __typename?: 'OfferingPackage';
              id: string;
            }> | null;
          } | null;
        } | null;
      };
  coach: {
    __typename?: 'Coach';
    id: string;
    user: { __typename?: 'User'; id: string; firstName: string };
  };
  recurringSession?: { __typename?: 'RecurringSession'; id: string } | null;
};

export type AddAdditionalTimeOrderFragment = {
  __typename?: 'Order';
  id: string;
  finalAmount?: number | null;
  hourlyOrder?: { __typename?: 'HourlyOrder'; timeInMinute: number } | null;
};

export type AddAdditionalTimeCreateOrderMutationVariables = Types.Exact<{
  coachUrn: Types.Scalars['CoachUrn']['input'];
  hourlyOrder: Types.HourlyOrderInput;
  categoryUrn?: Types.InputMaybe<Types.Scalars['CategoryUrn']['input']>;
}>;

export type AddAdditionalTimeCreateOrderMutation = {
  __typename?: 'Mutation';
  createOrder: {
    __typename?: 'Order';
    id: string;
    finalAmount?: number | null;
    hourlyOrder?: { __typename?: 'HourlyOrder'; timeInMinute: number } | null;
  };
};

export type AddAdditionalTimeInitialLoadQueryVariables = Types.Exact<{
  coachUrn: Types.Scalars['CoachUrn']['input'];
}>;

export type AddAdditionalTimeInitialLoadQuery = {
  __typename?: 'Query';
  activeCustomerSubscriptions: Array<{
    __typename?: 'CustomerSubscription';
    id: string;
    useSkuUnitPrice: boolean;
    sku: { __typename?: 'Sku'; id: string; unitPrice: number };
  }>;
};

export type AddAdditionalTimeSkuQueryVariables = Types.Exact<{
  numberOfSessions: Types.Scalars['Int']['input'];
  period: Types.SubscriptionInterval;
  tier: Types.SkuTier;
}>;

export type AddAdditionalTimeSkuQuery = {
  __typename?: 'Query';
  findSkuBySession: { __typename?: 'Sku'; id: string };
};

export type AddAdditionalTimeAdditionalTimeNeededToScheduleQueryVariables =
  Types.Exact<{
    coachUrn: Types.Scalars['CoachUrn']['input'];
    startAt: Types.Scalars['Long']['input'];
    endAt: Types.Scalars['Long']['input'];
    excludeSessions:
      | Array<Types.Scalars['CoachingSessionUrn']['input']>
      | Types.Scalars['CoachingSessionUrn']['input'];
  }>;

export type AddAdditionalTimeAdditionalTimeNeededToScheduleQuery = {
  __typename?: 'Query';
  additionalTimeNeededToSchedule: number;
};

export const AddAdditionalTimeCoachFragmentDoc = gql`
  fragment AddAdditionalTime_Coach on Coach {
    id
    hourlyRate
    coachingTimeSummary {
      availableTime
    }
    categoryInformationList {
      id
      category {
        id
      }
      coachingFocusList {
        ...BookHourlyCoachingModal_CoachingFocus
      }
    }
    ...BaseScheduleSubmissionModalLayout_Coach
    ...BookCoachingTimeForm_Coach
  }
  ${BookHourlyCoachingModalCoachingFocusFragmentDoc}
  ${BaseScheduleSubmissionModalLayoutCoachFragmentDoc}
  ${BookCoachingTimeFormCoachFragmentDoc}
`;
export const AddAdditionalTimeCoachingSessionFragmentDoc = gql`
  fragment AddAdditionalTime_CoachingSession on CoachingSession {
    ...BaseScheduleModalLayout_CoachingSession
  }
  ${BaseScheduleModalLayoutCoachingSessionFragmentDoc}
`;
export const AddAdditionalTimeOrderFragmentDoc = gql`
  fragment AddAdditionalTime_Order on Order {
    id
    finalAmount
    ...BaseScheduleModalLayout_Order
  }
  ${BaseScheduleModalLayoutOrderFragmentDoc}
`;
export const AddAdditionalTimeCreateOrderDocument = gql`
  mutation AddAdditionalTime_CreateOrder(
    $coachUrn: CoachUrn!
    $hourlyOrder: HourlyOrderInput!
    $categoryUrn: CategoryUrn
  ) {
    createOrder(
      coachUrn: $coachUrn
      hourlyOrder: $hourlyOrder
      categoryUrn: $categoryUrn
    ) {
      ...AddAdditionalTime_Order
    }
  }
  ${AddAdditionalTimeOrderFragmentDoc}
`;
export type AddAdditionalTimeCreateOrderMutationFn = Apollo.MutationFunction<
  AddAdditionalTimeCreateOrderMutation,
  AddAdditionalTimeCreateOrderMutationVariables
>;

/**
 * __useAddAdditionalTimeCreateOrderMutation__
 *
 * To run a mutation, you first call `useAddAdditionalTimeCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAdditionalTimeCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAdditionalTimeCreateOrderMutation, { data, loading, error }] = useAddAdditionalTimeCreateOrderMutation({
 *   variables: {
 *      coachUrn: // value for 'coachUrn'
 *      hourlyOrder: // value for 'hourlyOrder'
 *      categoryUrn: // value for 'categoryUrn'
 *   },
 * });
 */
export function useAddAdditionalTimeCreateOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddAdditionalTimeCreateOrderMutation,
    AddAdditionalTimeCreateOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddAdditionalTimeCreateOrderMutation,
    AddAdditionalTimeCreateOrderMutationVariables
  >(AddAdditionalTimeCreateOrderDocument, options);
}
export type AddAdditionalTimeCreateOrderMutationHookResult = ReturnType<
  typeof useAddAdditionalTimeCreateOrderMutation
>;
export type AddAdditionalTimeCreateOrderMutationResult =
  Apollo.MutationResult<AddAdditionalTimeCreateOrderMutation>;
export type AddAdditionalTimeCreateOrderMutationOptions =
  Apollo.BaseMutationOptions<
    AddAdditionalTimeCreateOrderMutation,
    AddAdditionalTimeCreateOrderMutationVariables
  >;
export const AddAdditionalTimeInitialLoadDocument = gql`
  query AddAdditionalTime_InitialLoad($coachUrn: CoachUrn!) {
    activeCustomerSubscriptions: customerSubscriptions(
      coachUrn: $coachUrn
      statuses: [ACTIVE]
    ) {
      id
      useSkuUnitPrice
      sku {
        id
        unitPrice
      }
    }
  }
`;

/**
 * __useAddAdditionalTimeInitialLoadQuery__
 *
 * To run a query within a React component, call `useAddAdditionalTimeInitialLoadQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddAdditionalTimeInitialLoadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddAdditionalTimeInitialLoadQuery({
 *   variables: {
 *      coachUrn: // value for 'coachUrn'
 *   },
 * });
 */
export function useAddAdditionalTimeInitialLoadQuery(
  baseOptions: Apollo.QueryHookOptions<
    AddAdditionalTimeInitialLoadQuery,
    AddAdditionalTimeInitialLoadQueryVariables
  > &
    (
      | {
          variables: AddAdditionalTimeInitialLoadQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AddAdditionalTimeInitialLoadQuery,
    AddAdditionalTimeInitialLoadQueryVariables
  >(AddAdditionalTimeInitialLoadDocument, options);
}
export function useAddAdditionalTimeInitialLoadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AddAdditionalTimeInitialLoadQuery,
    AddAdditionalTimeInitialLoadQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AddAdditionalTimeInitialLoadQuery,
    AddAdditionalTimeInitialLoadQueryVariables
  >(AddAdditionalTimeInitialLoadDocument, options);
}
export function useAddAdditionalTimeInitialLoadSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AddAdditionalTimeInitialLoadQuery,
    AddAdditionalTimeInitialLoadQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AddAdditionalTimeInitialLoadQuery,
    AddAdditionalTimeInitialLoadQueryVariables
  >(AddAdditionalTimeInitialLoadDocument, options);
}
export type AddAdditionalTimeInitialLoadQueryHookResult = ReturnType<
  typeof useAddAdditionalTimeInitialLoadQuery
>;
export type AddAdditionalTimeInitialLoadLazyQueryHookResult = ReturnType<
  typeof useAddAdditionalTimeInitialLoadLazyQuery
>;
export type AddAdditionalTimeInitialLoadSuspenseQueryHookResult = ReturnType<
  typeof useAddAdditionalTimeInitialLoadSuspenseQuery
>;
export type AddAdditionalTimeInitialLoadQueryResult = Apollo.QueryResult<
  AddAdditionalTimeInitialLoadQuery,
  AddAdditionalTimeInitialLoadQueryVariables
>;
export const AddAdditionalTimeSkuDocument = gql`
  query AddAdditionalTime_Sku(
    $numberOfSessions: Int!
    $period: SubscriptionInterval!
    $tier: SkuTier!
  ) {
    findSkuBySession(
      numberOfSessions: $numberOfSessions
      period: $period
      tier: $tier
    ) {
      id
    }
  }
`;

/**
 * __useAddAdditionalTimeSkuQuery__
 *
 * To run a query within a React component, call `useAddAdditionalTimeSkuQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddAdditionalTimeSkuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddAdditionalTimeSkuQuery({
 *   variables: {
 *      numberOfSessions: // value for 'numberOfSessions'
 *      period: // value for 'period'
 *      tier: // value for 'tier'
 *   },
 * });
 */
export function useAddAdditionalTimeSkuQuery(
  baseOptions: Apollo.QueryHookOptions<
    AddAdditionalTimeSkuQuery,
    AddAdditionalTimeSkuQueryVariables
  > &
    (
      | { variables: AddAdditionalTimeSkuQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AddAdditionalTimeSkuQuery,
    AddAdditionalTimeSkuQueryVariables
  >(AddAdditionalTimeSkuDocument, options);
}
export function useAddAdditionalTimeSkuLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AddAdditionalTimeSkuQuery,
    AddAdditionalTimeSkuQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AddAdditionalTimeSkuQuery,
    AddAdditionalTimeSkuQueryVariables
  >(AddAdditionalTimeSkuDocument, options);
}
export function useAddAdditionalTimeSkuSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AddAdditionalTimeSkuQuery,
    AddAdditionalTimeSkuQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AddAdditionalTimeSkuQuery,
    AddAdditionalTimeSkuQueryVariables
  >(AddAdditionalTimeSkuDocument, options);
}
export type AddAdditionalTimeSkuQueryHookResult = ReturnType<
  typeof useAddAdditionalTimeSkuQuery
>;
export type AddAdditionalTimeSkuLazyQueryHookResult = ReturnType<
  typeof useAddAdditionalTimeSkuLazyQuery
>;
export type AddAdditionalTimeSkuSuspenseQueryHookResult = ReturnType<
  typeof useAddAdditionalTimeSkuSuspenseQuery
>;
export type AddAdditionalTimeSkuQueryResult = Apollo.QueryResult<
  AddAdditionalTimeSkuQuery,
  AddAdditionalTimeSkuQueryVariables
>;
export const AddAdditionalTimeAdditionalTimeNeededToScheduleDocument = gql`
  query AddAdditionalTime_additionalTimeNeededToSchedule(
    $coachUrn: CoachUrn!
    $startAt: Long!
    $endAt: Long!
    $excludeSessions: [CoachingSessionUrn!]!
  ) {
    additionalTimeNeededToSchedule(
      coachUrn: $coachUrn
      startAt: $startAt
      endAt: $endAt
      excludeSessions: $excludeSessions
    )
  }
`;

/**
 * __useAddAdditionalTimeAdditionalTimeNeededToScheduleQuery__
 *
 * To run a query within a React component, call `useAddAdditionalTimeAdditionalTimeNeededToScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddAdditionalTimeAdditionalTimeNeededToScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddAdditionalTimeAdditionalTimeNeededToScheduleQuery({
 *   variables: {
 *      coachUrn: // value for 'coachUrn'
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *      excludeSessions: // value for 'excludeSessions'
 *   },
 * });
 */
export function useAddAdditionalTimeAdditionalTimeNeededToScheduleQuery(
  baseOptions: Apollo.QueryHookOptions<
    AddAdditionalTimeAdditionalTimeNeededToScheduleQuery,
    AddAdditionalTimeAdditionalTimeNeededToScheduleQueryVariables
  > &
    (
      | {
          variables: AddAdditionalTimeAdditionalTimeNeededToScheduleQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AddAdditionalTimeAdditionalTimeNeededToScheduleQuery,
    AddAdditionalTimeAdditionalTimeNeededToScheduleQueryVariables
  >(AddAdditionalTimeAdditionalTimeNeededToScheduleDocument, options);
}
export function useAddAdditionalTimeAdditionalTimeNeededToScheduleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AddAdditionalTimeAdditionalTimeNeededToScheduleQuery,
    AddAdditionalTimeAdditionalTimeNeededToScheduleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AddAdditionalTimeAdditionalTimeNeededToScheduleQuery,
    AddAdditionalTimeAdditionalTimeNeededToScheduleQueryVariables
  >(AddAdditionalTimeAdditionalTimeNeededToScheduleDocument, options);
}
export function useAddAdditionalTimeAdditionalTimeNeededToScheduleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AddAdditionalTimeAdditionalTimeNeededToScheduleQuery,
    AddAdditionalTimeAdditionalTimeNeededToScheduleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AddAdditionalTimeAdditionalTimeNeededToScheduleQuery,
    AddAdditionalTimeAdditionalTimeNeededToScheduleQueryVariables
  >(AddAdditionalTimeAdditionalTimeNeededToScheduleDocument, options);
}
export type AddAdditionalTimeAdditionalTimeNeededToScheduleQueryHookResult =
  ReturnType<typeof useAddAdditionalTimeAdditionalTimeNeededToScheduleQuery>;
export type AddAdditionalTimeAdditionalTimeNeededToScheduleLazyQueryHookResult =
  ReturnType<
    typeof useAddAdditionalTimeAdditionalTimeNeededToScheduleLazyQuery
  >;
export type AddAdditionalTimeAdditionalTimeNeededToScheduleSuspenseQueryHookResult =
  ReturnType<
    typeof useAddAdditionalTimeAdditionalTimeNeededToScheduleSuspenseQuery
  >;
export type AddAdditionalTimeAdditionalTimeNeededToScheduleQueryResult =
  Apollo.QueryResult<
    AddAdditionalTimeAdditionalTimeNeededToScheduleQuery,
    AddAdditionalTimeAdditionalTimeNeededToScheduleQueryVariables
  >;
